import React from 'react';
import { useParams } from 'react-router-dom';

const CustomerDetail = () => {
  const { id } = useParams();

  return (
    <div>
      <div className="content-header">
        <h1>Kundendetails</h1>
        <p>Kunde ID: {id}</p>
      </div>
      <div className="content-body">
        <div className="card">
          <div className="card-body">
            <p>Kundendetails werden hier angezeigt.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerDetail;